import { createParser, system } from "@styled-system/core";
var config = {
  animation: true,
  appearance: true,
  visibility: true,
  userSelect: true,
  pointerEvents: true,
  cursor: true,
  resize: true,
  objectFit: true,
  objectPosition: true,
  float: true,
  willChange: true
};
export var others = system(config);
export var othersParser = createParser(config);
//# sourceMappingURL=others.js.map